module.exports = __webpack_public_path__ + "img/logo_60_p.b005408a.svg";